// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container {\n  width: 100%;\n  height: 100%;\n}\n.container .video-tag {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: flex;\n}\n._kwai-player-poster_uxc1a_19 {\n  background-color: #000;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
